import Component from 'vue-class-component'
import Vue from 'vue'

@Component({
  name: 'removeButton'
})
export default class RemoveButton extends Vue {
}
